<p>
  un-authorize works!
</p>
